<template>
    <header
        v-show="isMobile && $route.name != routeToName"
        class="cabinet-header flex flex-align-center"
    >
        <router-link
            :to="{ name: routeToName }"
            class="cabinet-btn--form-back-header-edit"
        ></router-link>
        <h1 class="h1 cabinet-title">{{ title }}</h1>
    </header>
</template>

<script>
import onResize from '@/mixins/on-resize'

export default {
    name: 'TabsHeaderMobile',
    mixins: [onResize],
    props: {
        routeToName: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        }
    }
}
</script>
